export default __webpack_public_path__ + "static/devesecops-support4-472877508501f6aeac37c57c784540ea.jpg";